import { Layout } from "antd";
import Title from "antd/es/typography/Title";
import React from "react";
import { UsersComponent } from "../features/users/UsersComponent";

const UsersPage: React.FC = () => (
  <Layout className="p-8">
    <Title className="ml-2 !mt-0" level={1}>
      Пользователи
    </Title>
    <UsersComponent />
  </Layout>
);

export default UsersPage;
